import { COMPLAINT_STATUS_LABELS, PROMISE_STATUS_LABELS, VERIFICATION_LABELS } from "@shared/taxonomy";
import { getLang, labelIn } from "./i18n";

const locale = () => (getLang() === "hi" ? "hi-IN" : "en-IN");

export function fmtDate(v: string | null | undefined, opts: Intl.DateTimeFormatOptions = { day: "numeric", month: "short", year: "numeric" }): string {
  if (!v) return "—";
  const d = new Date(v.length === 10 ? `${v}T00:00:00` : v);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleDateString(locale(), opts);
}

export function fmtDateTime(v: string | null | undefined): string {
  if (!v) return "—";
  return new Date(v).toLocaleString(locale(), { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function relTime(v: string | null | undefined): string {
  if (!v) return "";
  const s = (Date.now() - new Date(v).getTime()) / 1000;
  const hi = getLang() === "hi";
  if (s < 60) return hi ? "अभी-अभी" : "just now";
  if (s < 3600) return hi ? `${Math.floor(s / 60)} मिनट पहले` : `${Math.floor(s / 60)} min ago`;
  if (s < 86400) return hi ? `${Math.floor(s / 3600)} घंटे पहले` : `${Math.floor(s / 3600)} h ago`;
  if (s < 86400 * 30) return hi ? `${Math.floor(s / 86400)} दिन पहले` : `${Math.floor(s / 86400)} d ago`;
  return fmtDate(v);
}

export function fmtNumber(n: number | null | undefined): string {
  return n == null ? "—" : n.toLocaleString("en-IN");
}

export function fmtBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

export const statusLabel = (s: string) => labelIn(COMPLAINT_STATUS_LABELS[s] || s);
export const verificationLabel = (s: string) => labelIn(VERIFICATION_LABELS[s] || s);
export const promiseStatusLabel = (s: string) => labelIn(PROMISE_STATUS_LABELS[s] || s);
export const humanize = (s: string | null | undefined) => (s ? labelIn(s.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase())) : "");
